import { Injectable } from '@angular/core';
import { EntityService } from '../../../../rest/entity.service';
import { JQueryHTTPClient } from '../../../../rest/JQueryHTTPClient';
import { Rest_task } from './rest_client_task';
import { Rest } from '../../../../rest/rest_client';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { NotificationsService, Severity } from '../../../../services/notifications-service/notifications.service';
import { Rest_logistics } from '../../Logistics/services/rest_client_logistics';


@Injectable()
export class NotificationService extends EntityService<Rest_task.Route> {
    client: Rest.RestApplicationClient;

    constructor(
        private jquery: JQueryHTTPClient,
        private http: HttpClient,
        private auth: AuthenticationService,
        private notificationsService: NotificationsService,
    ) {
        super();
        this.client_logistics= new Rest_logistics.RestApplicationClient(jquery);
    }
    
    getNotifications(arg0: any): Rest.RestResponse<Rest_task.Notification[]> {
        return this.client_logistics.Notification_getNotifications(arg0);
    }

    setNotification(notification: Rest_task.Notification): Rest.RestResponse<Rest.GenericResp<Rest_task.Notification>> {
        return this.client_logistics.Notification_setNotification(notification);
    }

}
